import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DocumentAcceptRejectStore {
  hideAcceptRejectDocumentConfirmation: boolean;
  setHideAcceptRejectDocumentConfirmation: (hideAcceptRejectDocumentConfirmation: boolean) => void;
}

const initialState = {
  hideAcceptRejectDocumentConfirmation: false,
};

export const useDocumentAcceptRejectStore = create<DocumentAcceptRejectStore>()(
  persist(
    (set) => ({
      ...initialState,
      setHideAcceptRejectDocumentConfirmation: (hideAcceptRejectDocumentConfirmation) =>
        set({ hideAcceptRejectDocumentConfirmation }),
    }),
    {
      name: 'documentAcceptRejectStore',
      partialize(state) {
        return {
          hideAcceptRejectDocumentConfirmation: state.hideAcceptRejectDocumentConfirmation,
        };
      },
    },
  ),
);
